import Vue from 'vue';
import App from './App.vue';
import animate from 'animate.css';
import Velocity from 'velocity-animate';
import lodash from 'lodash';


Vue.config.productionTip = false;



new Vue({  
  render:h=>h(App),
}).$mount('#app')